import { ValidationButton } from '@axafr-btc-ds/buttons';

import { NextButtonProps } from './NextButton.interface';
import styles from './NextButton.module.css';

export function NextButton({
    isDisabled,
    isCentered,
    onClick,
    onMouseOver,
}: NextButtonProps): JSX.Element {
    return (
        <ValidationButton
            className={ styles.nextAction }
            isDisabled={ isDisabled }
            onClick={ onClick }
            onMouseOver={ onMouseOver }
            align={ isCentered ? 'center' : 'right' }
        >
            Étape suivante
        </ValidationButton>
    );
}
